class ProductBestSellersGrid extends HTMLElement {
  connectedCallback() {
    const visible = parseInt(this.dataset.visible || '4', 10);
    const tiles = Array.from(this.children);

    for (let i = tiles.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [tiles[i], tiles[j]] = [tiles[j], tiles[i]];
    }

    tiles.forEach((tile, i) => {
      if (i >= visible) {
        tile.remove();
      } else {
        this.appendChild(tile);
      }
    });

    this.classList.add('is-ready');
  }
}

customElements.define('product-best-sellers-grid', ProductBestSellersGrid);
